let barConfig = {
    indexAxis: 'y',
    plugins: {
        title: {
            display: true,
            text: 'Chart.js Bar Chart - Stacked'
        },
        legend:{
            labels:{
                sort:(a, b) => {
                    if(a.text === "Danger" ){
                        console.log(b)
                        return -1;
                    }else{
                        return 1;
                    }
                }
            }
        }
    },
    responsive: true,
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true
        }
    }
}

export default barConfig;